import React, { ForwardRefRenderFunction, forwardRef } from "react";
//#region types
import { FormEnums } from "models/enums";
import { FormHandles, TextFieldExtraProps } from "models/propTypes/genericFormProps";
import { TranslationKeys } from "translations";
import { IntegrationFormTypes } from "models/formTypes";
import { CustomIntegrationFormProps } from "models/propTypes/integrationsPropTypes";
//#endregion
//#region components
import { GenericForm } from "components/common";
import { Grid } from "@mui/material";
import { RefreshButton } from "components/common";
import { useSettingsService } from "serviceHooks";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";

const CustomIntegrationForm: ForwardRefRenderFunction<FormHandles, CustomIntegrationFormProps> = (props, ref) => {
  const settingsService = useSettingsService();
  const { onApiKeyRefresh } = props;
  return (
    <GenericForm<IntegrationFormTypes.CustomIntegration>
      formRef={ref}
      {...props}
      fields={{
        name: {
          label: TranslationKeys.Common.Name,
          type: FormEnums.FormFieldType.TEXT,
        },
        description: {
          label: TranslationKeys.Common.Description,
          type: FormEnums.FormFieldType.TEXT,
        },
        isActive: {
          label: TranslationKeys.Integrations.ActivateYourIntegration,
          type: FormEnums.FormFieldType.TOGGLE,
          classes: { formControl: cssExports.inlineLabel },
        },
        logingDetails: {
          label: "",
          type: FormEnums.FormFieldType.CUSTOM,
          customField: (
            <>
              <Grid container className={cssExports.formControlLabel}>
                {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Integrations.QbisLoginDetails)}
              </Grid>
              <Grid container className={cssExports.formControlDescription}>
                {LocalizationHelperInstance.getFormattedMessage(
                  TranslationKeys.Integrations.QbisLoginDetailsDescription
                )}
              </Grid>
            </>
          ),
        },
        userName: {
          label: TranslationKeys.Integrations.UserName,
          type: FormEnums.FormFieldType.TEXT,
          disabled: true,
          hidden: (values: IntegrationFormTypes.SimpleIntegration) => !values.isActive,
        },
        apiKey: {
          label: "",
          type: FormEnums.FormFieldType.HORIONTALFIELDGROUP,
          hidden: (values: IntegrationFormTypes.SimpleIntegration) => !values.isActive,
          innerFields: {
            apiKey: {
              label: TranslationKeys.Integrations.ApiKey,
              type: FormEnums.FormFieldType.TEXT,
              widthColumnCount: 11,
              disabled: true,
              extraProps: { showCopyButton: true } as TextFieldExtraProps,
            },
            refresh: {
              label: "",
              type: FormEnums.FormFieldType.CUSTOM,
              customField: (
                <RefreshButton onChange={() => {}} onClick={settingsService.generateCustomAppApiKey}></RefreshButton>
              ),
              onChangeHandler: onApiKeyRefresh,
              widthColumnCount: 1,
            },
          },
        },
      }}
    />
  );
};

export default forwardRef(CustomIntegrationForm);
